<!-- eslint-disable max-len -->

<template>
  <v-hover v-slot:default="{ hover }" open-delay="50">
    <v-card
      style="cursor: pointer"
      :class="getStatusClass(voyage.status)"
      :elevation="hover ? 16 : 4"
      @click="goToVoyageDetails(voyage)"
    >
      <v-container>
        <v-row class="text-start">
          <v-col cols="12" md="4" class="py-0 pl-0">
            <div class="d-flex flex-column col-min-height col-padding">
              <div class="d-flex">
                <span class="mb-4">
                  <v-avatar color="background" size="40">
                    <v-icon color="primary">mdi-ferry</v-icon>
                  </v-avatar>
                  <span class="ml-2 text-h6 primary--text">{{
                    voyage.vesselName
                  }}</span>
                </span>
                <v-spacer />
                <VoyageListCardStatus
                  :voyage="voyage"
                  class="hidden-md-and-up"
                />
              </div>
              <span
                class="d-inline-block text-h4 text-md-h3 text-xl-h2 primary--text font-weight-bold text-start text-truncate"
                style="max-width: 625px"
              >
                {{ voyage.voyageNo }}
              </span>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="py-0 pl-0">
            <div class="d-flex col-min-height col-padding">
              <v-divider vertical class="hidden-sm-and-down mr-4" />
              <div class="d-block">
                <v-avatar class="mb-4" color="background" size="40">
                  <v-icon color="primary">mdi-timeline-clock</v-icon>
                </v-avatar>
                <div class="text-h6 primary--text">Voyage Start/End (LT)</div>
                <div class="text-body-1" v-if="voyage.voyageStartDateTimeLt">
                  {{
                    voyage.voyageStartDateTimeLt
                      | removeTAndSecondsAndFormatDate
                  }}
                  <div
                    v-text="
                      voyage.voyageEndDateTimeLt
                        ? $options.filters.removeTAndSecondsAndFormatDate(
                            voyage.voyageEndDateTimeLt
                          )
                        : 'In Progress'
                    "
                  ></div>
                </div>
                <div v-else class="text-subtitle-1">Not Started</div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="py-0 pl-0">
            <div class="d-flex col-min-height col-padding">
              <v-divider vertical class="hidden-sm-and-down mr-4" />
              <div class="d-flex flex-column flex-grow-1">
                <div class="d-flex mb-4">
                  <v-avatar color="background" size="40">
                    <v-icon color="primary">mdi-map-marker</v-icon>
                  </v-avatar>
                  <v-spacer />
                  <VoyageListCardStatus
                    :voyage="voyage"
                    class="hidden-sm-and-down"
                  />
                </div>
                <span class="text-h6 primary--text">Initial Port</span>
                <div class="text-body-1">
                  {{ voyage.initialPort }}
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-hover>
</template>

<script>
import StatusColourMixin from '../../mixins/StatusColourMixin';
import VoyageReportsHelperMixin from '../../mixins/VoyageReportsHelperMixin';
import VoyageListCardStatus from './VoyageListCardStatus.vue';

export default {
  name: 'VoyageListCard',
  components: { VoyageListCardStatus },
  mixins: [VoyageReportsHelperMixin, StatusColourMixin],
  props: {
    voyage: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getStatusClass(status) {
      let borderStyle = '';
      switch (status) {
        case 'NotSet':
          borderStyle = 'not-set';
          break;
        case 'InProgress':
          borderStyle = 'in-progress';
          break;
        case 'Completed':
          borderStyle = 'complete';
          break;
        default:
          borderStyle = 'not-set';
          break;
      }
      return `rounded-lg status-border ${borderStyle}`;
    },
  },
};
</script>

<style scoped>
.col-min-height {
  min-height: 180px;
}

.col-padding {
  padding-left: 16px;
}

.status-border {
  border-left: 16px solid !important;
}
.not-set {
  border-color: gray !important;
}
.in-progress {
  border-color: orange !important;
}
.complete {
  border-color: #4caf50 !important;
}
</style>
